export default __webpack_public_path__ + "static/media/linkedin.61d435e2.svg";